module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('shared-provide-variation', {
    attrs: {
      "variation": _vm.variation,
      "fromModule": _vm.fromModule,
      "toModule": _vm.toModule
    },
    on: {
      "change": _vm.emitToParent
    }
  }, [(_vm.variation.attributes) ? _c('div', {
    staticClass: "divider"
  }, [_c('span', [_vm._v("Atributos")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "l-row"
  }, [_vm._l((_vm.variation.attributes), function(label, attribute) {
    return (_vm.variation.attributes) ? _c('form-group', {
      key: attribute,
      attrs: {
        "label": _vm.$t(attribute).label,
        "columns": 3,
        "error": _vm.getError('attributes.' + attribute, _vm.variation.sku)
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.variation.attributes[attribute]),
        expression: "variation.attributes[attribute]"
      }],
      staticClass: "form-select",
      attrs: {
        "disabled": _vm.disabledInputs()
      },
      domProps: {
        "value": (_vm.variation.attributes[attribute])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.variation.attributes, attribute, $event.target.value)
        }
      }
    })]) : _vm._e()
  }), _vm._v(" "), (_vm.variation.crossDocking) ? _c('form-group', {
    attrs: {
      "label": _vm.$t('crossDocking.label'),
      "columns": 3,
      "error": _vm.getError('crossDocking', _vm.variation.sku),
      "required": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.variation.crossDocking),
      expression: "variation.crossDocking"
    }],
    staticClass: "form-select",
    attrs: {
      "disabled": _vm.disabledInputs(),
      "type": "number"
    },
    domProps: {
      "value": (_vm.variation.crossDocking)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.variation, "crossDocking", $event.target.value)
      }
    }
  })]) : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-617019aa","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/marketplace/colombo/provide/Variation.vue
// module id = 3224
// module chunks = 0